import { render, staticRenderFns } from "./OnboardingGuestStep3.vue?vue&type=template&id=ae6e726c&scoped=true"
import script from "./OnboardingGuestStep3.vue?vue&type=script&lang=js"
export * from "./OnboardingGuestStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6e726c",
  null
  
)

export default component.exports